<template>
  	<vuestic-sidebar class="sidebar sidebar" :hidden="isOpen">

		<template slot="menu" v-if="id_role == 6">
			<sidebar-link :to="{ name: 'faturas_boletos' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-file-text-o"></span>
					<span>Faturamento AE</span>
				</span>
			</sidebar-link>
			<sidebar-link :to="{ name: 'faturas_cadastradas' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-user"></span>
					<span>Alunos Faturados</span>
				</span>
			</sidebar-link>
			<sidebar-link :to="{ name: 'Listar_alunos' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-user"></span>
					<span>Alunos Cadastradas</span>
				</span>
			</sidebar-link>
			<sidebar-link :to="{ name: 'relatorios' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-file"></span>
					<span>Relatórios</span>
				</span>
			</sidebar-link>
			<sidebar-link :to="{ name: 'faturamento-panel' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-file-text-o"></span>
					<span>Faturamento</span>
				</span>
			</sidebar-link>
			<sidebar-link :to="{ name: 'autoescolas' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-file-text-o"></span>
					<span>Autoescolas</span>
				</span>
			</sidebar-link>
			<sidebar-link-group>
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-university"></span>
					<span>Sindicato</span>
				</span>

				<sidebar-link :to="{ name: 'sindicato-recebimentos' }">
					<span slot="title">
						<span class="sidebar-menu-item-icon fa fa-file-text-o"></span>
						<span>Recebimento</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>
		</template>

	  	<template slot="menu" v-else-if="id_role == 2">

			<sidebar-link :to="{ name: 'DashboardMonitoramento' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-dashboard"></span>
					<span>Dashboard</span>
				</span>
			</sidebar-link>

			<sidebar-link :to="{ name: 'ListarAlunos' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-users"></span>
					<span>Alunos</span>
				</span>
			</sidebar-link>

			<!-- <sidebar-link :to="{ name: 'FeedAluno' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-cloud"></span>
					<span>Feed dos Alunos</span>
				</span>
			</sidebar-link> -->

			<sidebar-link-group>
				<span slot="title">
					<span
						class="sidebar-menu-item-icon fa fa-car-o"></span>
					<span>Praticas</span>
				</span>
				<sidebar-link :to="{ name: 'ListarAulasPraticas' }">
					<span slot="title">
						<span class="sidebar-menu-item-icon fa fa-calendar"></span>
						<span>Aulas Práticas</span>
					</span>
				</sidebar-link>
			</sidebar-link-group>

			<sidebar-link :to="{ name: 'ListarTurmasTeoricas' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-university"></span>
					<span>Turmas Teóricas</span>
				</span>
			</sidebar-link>

			<sidebar-link :to="{ name: 'ListarAulasVirtuais' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-television"></span>
					<span>Monitorar Teóricas</span>
				</span>
			</sidebar-link>
			<sidebar-link-group>

				<span slot="title">
					<span
						class="sidebar-menu-item-icon fa fa-clock-o"></span>
					<span>Cargas Horárias</span>
				</span>
				<sidebar-link :to="{ name: 'carga-horaria-teorica' }">
					<span slot="title">
						<span>Carga Horária Teórica</span>
					</span>
				</sidebar-link>
				<sidebar-link v-if="this.roles.agendamento" :to="{ name: 'processo-agendamento' }">
					<span slot="title">
						<span>Carga Horária Prática</span>
					</span>
				</sidebar-link>
			</sidebar-link-group>

			<sidebar-link :to="{ name: 'ListarInstrutores' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-pencil"></span>
					<span>Instrutores</span>
				</span>
			</sidebar-link>

			<sidebar-link :to="{ name: 'ListarVeiculos' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-car"></span>
					<span>Veículos</span>
				</span>
			</sidebar-link>

       	<sidebar-link :to="{ name: 'Avisos' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-comment-o"></span>
					<span>Avisos</span>
				</span>
			</sidebar-link>

			<sidebar-link :to="{ name: 'ListarRelatorios' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-file-text-o"></span>
					<span>Relatórios</span>
				</span>
			</sidebar-link>
			<sidebar-link :to="{ name: 'ListarSalas' }">
				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-bar-chart"></span>
					<span>Salas</span>
				</span>
			</sidebar-link>

		</template>

		<template slot="menu" v-else-if="id_role == 3 && 2">
<!--
			<sidebar-link-group>

				<span slot="title">
					<span
						class="sidebar-menu-item-icon fa fa-university"></span>
					<span>Turmas</span>
				</span>

				<sidebar-link :to="{ name: 'listagem-turmas' }">
					<span slot="title">
						<span>Listar turmas</span>
					</span>
				</sidebar-link>

			</sidebar-link-group> -->

		</template>

		<template slot="menu" v-else-if="id_role == 4">
			<sidebar-link :to="{ name: 'aulas-teoricas' }">
				<span slot="title">
					<span
						class="sidebar-menu-item-icon fa fa-university"></span>
					<span>Aulas Teóricas</span>
				</span>
			</sidebar-link>

			<sidebar-link :to="{ name: 'aulas-praticas' }">
				<span slot="title">
					<span
						class="sidebar-menu-item-icon fa fa-calendar"></span>
					<span>Aulas Práticas</span>
				</span>
			</sidebar-link>
		</template>

    <template slot="menu" v-else-if="id_role == 9">
      <sidebar-link :to="{ name: 'Getran-listarAlunos' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon fa fa-users"></span>
          <span>Alunos</span>
        </span>
      </sidebar-link>

      <sidebar-link :to="{ name: 'Getran-ListarAulasPraticas' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon fa fa-calendar"></span>
          <span>Aulas Práticas</span>
        </span>
      </sidebar-link>

			<sidebar-link :to="{ name: 'Getran-ListarTurmasTeoricas' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon fa fa-university"></span>
          <span>Turmas Teóricas</span>
        </span>
      </sidebar-link>

			<sidebar-link :to="{ name: 'Getran-ListarAlertas' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon fa fa-bell"></span>
          <span>Alertas</span>
        </span>
      </sidebar-link>

			<sidebar-link :to="{ name: 'Getran-ListarInstrutores' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon fa fa-pencil"></span>
          <span>Instrutores</span>
        </span>
      </sidebar-link>

			<sidebar-link :to="{ name: 'Getran-ListarVeiculos' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon fa fa-car"></span>
          <span>Veículos</span>
        </span>
      </sidebar-link>

      <!-- <sidebar-link :to="{ name: 'Getran-ListarRelatorios' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon fa fa-file-text-o"></span>
          <span>Relatórios</span>
        </span>
      </sidebar-link> -->
    </template>


		<template slot="menu" v-else>

			<sidebar-link :to="{ name: 'dashboard' }">
				<span slot="title">
					<span
						class="sidebar-menu-item-icon vuestic-icon vuestic-icon-dashboard"></span>
					<span>{{ $t('menu.dashboard') }}</span>
				</span>
			</sidebar-link>

			<sidebar-link-group v-if="this.roles.alunos_list || this.roles.alunos_edit">

				<span slot="title">
					<span
						class="sidebar-menu-item-icon fa fa-users"></span>
					<span>Alunos</span>
				</span>

				<!-- <sidebar-link v-if="this.roles.alunos_edit" :to="{ name: 'novo-aluno' }">
					<span slot="title">
						<span>Novo aluno</span>
					</span>
				</sidebar-link> -->

				<sidebar-link v-if="this.roles.alunos_edit" :to="{ name: 'novo-aluno-basic' }">
					<span slot="title">
						<span>Novo aluno </span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.alunos_list" :to="{ name: 'listagem-alunos' }">
					<span slot="title">
						<span>Listar alunos</span>
					</span>
				</sidebar-link>

				<!-- <sidebar-link v-if="this.id_role == 1" :to="{ name: 'FeedAlunos' }">
					<span slot="title">
						<span>Feed</span>
					</span>
				</sidebar-link> -->

				<!-- <sidebar-link v-if="this.roles.id_permissao == 1 || this.roles.id_permissao == 2" :to="{ name: 'alunos-reposicao' }">
					<span slot="title">
						<span>Alunos de Reposição</span>
					</span>
				</sidebar-link> -->

			</sidebar-link-group>

			<sidebar-link-group v-if="this.roles.agendamento || this.roles.aulas_list || this.roles.planos">
				<span slot="title">
					<span
						class="sidebar-menu-item-icon fa fa-calendar"></span>
					<span>Aulas Práticas</span>
				</span>

                <sidebar-link :to="{ name: 'perimetro-index' }">
                    <span slot="title">
                        <span>Cadastro do perímetro</span>
                    </span>
                </sidebar-link>

                <sidebar-link v-if="this.roles.agendamento" :to="{ name: 'processo-agendamento' }">
                    <span slot="title">
                        <span>Consultar Carga Horária</span>
                    </span>
                </sidebar-link>

        <sidebar-link v-if="this.roles.agendamento" :to="{name: 'processo-index'}">
          <span slot="title">
            <span>Buscar Aulas Práticas</span>
          </span>
        </sidebar-link>

				<!-- <sidebar-link v-if="this.roles.agendamento" :to="{ name: 'aulas-agenda' }">
					<span slot="title">
						<span>Agenda</span>
					</span>
				</sidebar-link> -->

				<sidebar-link v-if="this.roles.agendamento" :to="{ name: 'agendar-pratica' }">
					<span slot="title">
						<span>Agendar aula prática</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.aulas_list" :to="{ name: 'aulas-agendadas' }">
					<span slot="title">
						<span>Listar aulas agendadas</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.aulas_list" :to="{ name: 'aulas-realizadas' }">
					<span slot="title">
						<span>Listar aulas realizadas</span>
					</span>
				</sidebar-link>

				<!-- <sidebar-link v-if="this.roles.planos" :to="{ name: 'planos-praticos' }">
					<span slot="title">
						<span>Planos Práticos</span>
					</span>
				</sidebar-link> -->

			</sidebar-link-group>

			<sidebar-link-group v-if="this.roles.turmas_edit || this.roles.turmas_list">

				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-university"></span>
					<span>Aulas Teóricas</span>
				</span>

				<!-- <sidebar-link v-if="this.roles.turmas_edit" :to="{ name: 'nova-turma' }">
					<span slot="title">
						<span>Nova turma</span>
					</span>
				</sidebar-link> -->
				<sidebar-link v-if="this.roles.agendamento" :to="{ name: 'carga-horaria-teorica' }">
					<span slot="title">
						<span>Consultar Carga Horária Teórica</span>
					</span>
				</sidebar-link>
				<sidebar-link v-if="this.roles.turmas_list" :to="{ name: 'listagem-turmas' }">
					<span slot="title">
						<span>Listar turmas</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.turmas_list" :to="{ name: 'aulas-presenciais' }">
					<span slot="title">
						<span>Aulas Presenciais</span>
					</span>
				</sidebar-link>

				<!-- <div class="sidebar-link" v-if="this.roles.turmas_list">
					<span slot="title">
						<a href="#" @click="loadData()" class="sidebar-link__router-link" style="padding-right: 2px">
							Relatório de turmas
						</a>
						<a href="#" hidden id="downloadTurmasPDF"></a>
					</span>
				</div> -->

			</sidebar-link-group>

			<sidebar-link-group v-if="this.cfc == 'public' && this.roles.cfcs">

				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-road"></span>
					<span>CFCs</span>
				</span>

				<sidebar-link v-if="this.roles.cfcs" :to="{ name: 'cfc' }">
					<span slot="title">
						<span>Listar CFCs</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.cfcs" :to="{ name: 'cfc-novo' }">
					<span slot="title">
						<span>Novo cadastro</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

			<sidebar-link-group v-if="this.roles.faturas_teoricas || this.roles.faturas_praticas">

				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-file-text-o"></span>
					<span>Faturas</span>
				</span>

				<sidebar-link v-if="this.roles.faturas_teoricas" :to="{ name: 'faturas-index' }">
					<span slot="title">
						<span>Faturas</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.faturas_teoricas" :to="{ name: 'importarFaturas' }">
					<span slot="title">
						<span>Importar Faturas</span>
					</span>
				</sidebar-link>

				<!-- <sidebar-link v-if="this.roles.faturas_teoricas" :to="{ name: 'faturas-teoricas' }">
					<span slot="title">
						<span>Faturas Teóricas</span>
					</span>
				</sidebar-link> -->

				<!-- <sidebar-link v-if="this.roles.faturas_praticas" :to="{ name: 'faturas-praticas' }">
					<span slot="title">
						<span>Faturas Práticas</span>
					</span>
				</sidebar-link> -->

			</sidebar-link-group>

			<sidebar-link-group v-if="this.roles.instrutor_list || this.roles.instrutor_edit">

				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-pencil"></span>
					<span>Instrutores</span>
				</span>

				<!-- <sidebar-link v-if="this.roles.instrutor_edit" :to="{ name: 'novo-instrutor' }">
					<span slot="title">
						<span>Novo instrutor</span>
					</span>
				</sidebar-link> -->

				<sidebar-link v-if="this.roles.instrutor_list" :to="{ name: 'listagem-instrutores' }">
					<span slot="title">
						<span>Listar instrutores</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

			<sidebar-link-group v-if="this.roles.monitoramento_teorica || this.roles.monitoramento_relatorios">

				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-television"></span>
					<span>Monitoramento</span>
				</span>
<!--
				<sidebar-link v-if="this.roles.monitoramento_teorica" :to="{ name: 'monitoramento-pratica' }">
					<span slot="title">
						<span>Monitorar aulas práticas</span>
					</span>
				</sidebar-link> -->

				<sidebar-link v-if="this.roles.id_permissao == 1 || this.roles.id_permissao == 2" :to="{ name: 'monitoramento-virtual' }">
					<span slot="title">
						<span>Monitorar aulas virtuais</span>
					</span>
				</sidebar-link>

				<!-- <sidebar-link v-if="this.roles.id_permissao == 1 || this.roles.id_permissao == 2" :to="{ name: 'monitoramento-teorica' }">
					<span slot="title">
						<span>Monitorar aulas teóricas</span>
					</span>
				</sidebar-link> -->

				<!-- <sidebar-link v-if="this.roles.monitoramento_teorica" :to="{ name: 'upload-foto-teorica' }">
					<span slot="title">
						<span>Upload de fotos teóricas</span>
					</span>
				</sidebar-link> -->

				<sidebar-link v-if="this.roles.monitoramento_relatorios" :to="{ name: 'relatorio-monitoramento' }">
					<span slot="title">
						<span>Relatórios</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.monitoramento_relatorios" :to="{ name: 'alertas' }">
					<span slot="title">
						<span>Alertas</span>
					</span>
				</sidebar-link>

				<!-- <sidebar-link v-if="this.roles.monitoramento_relatorios" :to="{ name: 'fotos-teoricas' }">
					<span slot="title">
						<span>Verificar Fotos</span>
					</span>
				</sidebar-link> -->

				<!-- <sidebar-link v-if="this.roles.monitoramento_relatorios" :to="{ name: 'status-cameras' }">
					<span slot="title">
						<span>Câmeras</span>
					</span>
				</sidebar-link> -->

			</sidebar-link-group>

			<sidebar-link-group v-if="this.roles.relatorios">

				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-bar-chart"></span>
					<span>Relatórios</span>
				</span>

				<sidebar-link v-if="this.roles.relatorios" :to="{ name: 'geral' }">
					<span slot="title">
						<span>Geral</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.relatorios" :to="{ name: 'acoes-usuarios' }">
					<span slot="title">
						<span>Ações dos Usuários</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.cfc == 'public' && this.roles.relatorios" :to="{ name: 'faturamento' }">
					<span slot="title">
						<span>Faturamento</span>
					</span>
				</sidebar-link>

				<!-- <div class="sidebar-link" v-if="this.roles.relatorios">
					<span slot="title">
						<a @click="gerarBoleto" class="sidebar-link__router-link" style="padding-right:2px">Relatório de Aulas Práticas Padrão Manual</a>
					</span>
				</div> -->

			</sidebar-link-group>

			<sidebar-link-group v-if="this.roles.user_list || this.roles.user_edit || this.roles.permissoes">

				<span slot="title">
					<span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-user"></span>
					<span>Usuários</span>
				</span>

				<sidebar-link v-if="this.roles.user_edit" :to="{ name: 'novo-usuario' }">
					<span slot="title">
						<span>Novo usuário</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.user_list" :to="{ name: 'listagem-usuarios' }">
					<span slot="title">
						<span>Listar usuários</span>
					</span>
				</sidebar-link>

				<sidebar-link v-if="this.roles.permissoes" :to="{ name: 'permissoes' }">
					<span slot="title">
						<span>Permissões</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

			<sidebar-link-group v-if="this.roles.veiculo_list || this.roles.veiculo_edit">

				<span slot="title">
					<span class="sidebar-menu-item-icon fa fa-car"></span>
					<span>Veículos</span>
				</span>

				<!-- <sidebar-link v-if="this.roles.veiculo_edit" :to="{ name: 'novo-veiculo' }">
					<span slot="title">
						<span>Novo veículo</span>
					</span>
				</sidebar-link> -->

				<sidebar-link v-if="this.roles.veiculo_list" :to="{ name: 'listagem-veiculos' }">
					<span slot="title">
						<span>Listar veículos</span>
					</span>
				</sidebar-link>

			</sidebar-link-group>

		</template>

	</vuestic-sidebar>
</template>

<script>
import VuesticSidebar from '../../../vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar'
import SidebarLink from './components/SidebarLink'
import SidebarLinkGroup from './components/SidebarLinkGroup'
// import VueResource from 'vue-resource'
import urlApi from '@/router/urlApi'
import jsPDF from 'jspdf'

// Vue.use(VueResource)
export default {
  data () {
    return {
      roles: JSON.parse(localStorage.permissions),
      cfc: localStorage.cfc,
      id_role: localStorage.id_role,
      isMobile: false
    }
  },
  name: 'app-sidebar',
  components: {
    VuesticSidebar,
    SidebarLink,
    SidebarLinkGroup
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },

  mounted () {
    this.$http.get(urlApi + '/login/autenticate').then(function (data) {
      console.log(data.status)
    })
    if (window.innerWidth <= 991) {
      this.isMobile = true
    }
  },

  methods: {
    downloadTurmasPDF (response) {
      let code64 = response.data.dados

      var pdf = 'data:application/octet-stream;base64,' + code64

      var dlnk = document.getElementById('downloadTurmasPDF')
      dlnk.download = 'lista_de_turmas.pdf'
      dlnk.href = pdf
      dlnk.click()
    },

    // async loadData () {
	// 		this.$toasted.show("Baixando relatório de turmas, aguarde!", {
    //     position: "top-right",
    //   });

    //   await this.$http.get(urlApi + '/turmas/lista/pdf')
	// 			.then(this.downloadTurmasPDF)
	// 			.catch(err => {
	// 				this.$toasted.show("Erro ao baixar relatório de turmas.", {
	// 					position: "top-right",
	// 				});
	// 			})
    // },

    gerarBoleto () {
      var doc = new jsPDF()

      doc.text('Relatório de Aula Prática Padrão', 10, 10)
      doc.line(0, 12, 1000, 12)
      doc.line(8, 0, 8, 1000)
      doc.line(0, 290, 1000, 290)
      doc.line(200, 0, 200, 1000)

      // console.log(navigator.userAgent)
      window.open(doc.output('bloburl'))
    }
  }
}
</script>

<style scoped>
	span {
		font-weight: bold;
	}
  @media (max-width: 991px){
    .sidebar{
      width: 25%;
    }
  }
   @media (max-width: 850px){
    .sidebar{
      width: 28%;
    }
  }
   @media (max-width: 720px){
    .sidebar{
      width: 33%;
    }
  }
  @media (max-width: 637px) {
    .sidebar {
      width: 40%;
    }
  }
  @media(max-width: 450px){
    .sidebar {
      width: 50%;
    }
  }
   @media(max-width: 390px){
    .sidebar {
      width: 50%;
    }
  }
   @media(max-width: 375px){
    .sidebar {
      width: 65%;
    }
  }
</style>
